import _Modal from './Modal'
import _Confirm from './Confirm'

export const Confirm = _Confirm
export const Modal = _Modal
export default _Modal
